var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.716,2.033l-8.839,8.6a1.244,1.244,0,0,1-1.768,0L.322,6.946a1.172,1.172,0,0,1,.126-1.72,1.357,1.357,0,0,1,1.641,0l2.9,2.825L12.948.313a1.243,1.243,0,0,1,1.768.123A1.264,1.264,0,0,1,14.716,2.033Z"}));
}

Checkmark.defaultProps = {"width":"15","height":"11","viewBox":"0 0 15 11"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
